<template>
  <div class="select-container" @click="toggleDropdown" :class="{'has-value': !showDropdown && selectedArray.length > 0}">
    <img class="icon-search" :src="`${$assetsCdn}/icons/icon-search.svg`"  />
    <div class="place-holder gray-dark fs-14 lh-17 arial" v-if="!showDropdown && selectedArray.length === 0">{{placeHolderText}}</div>
    <ul :class="showDropdown ? 'wp-100' : ''">
      <li class="arial" :class="showDropdown ? 'select-item styling' : 'select-item'" v-for="(select, index) in selectedArray" :key="index">
        <span>{{ showDropdown ? select.name : select.name }}</span>
        <span v-if="!showDropdown && index + 1 < selectedArray.length">,</span>
        <img :class="showDropdown ? 'icon-delete styling' : 'icon-delete'" :src="`${$assetsCdn}/icons/icon-menu.svg`"  @click="handleRemove(index)"/>
      </li>
      <li v-if="selectedArray.length >= 0"
      :class="{
        'dn' : !showDropdown,
        'wp-100': selectedArray.length === 0
      }">
        <input
          ref='searchRef'
          type="text"
          class="input-search"
          :class="selectedArray.length === 0 ? 'input-full' : ''"
          :placeholder="selectedArray.length === 0 ? placeHolderText : 'Where else?'"
          @keyup.enter="handleEnterKey()"
          v-model="searchQuery"/>
      </li>
    </ul>
  </div>
  <div
    class="options custom-option absolute bd-1 bd-gray-medium bg-white pt-8 pb-8 br-12 wp-100 mt-8 z-9999 overflow-auto maxh-280 arial"
    v-if="showDropdown"
    v-ClickOutside="closeDropdown"
  >
    <div v-if='searchQuery'>
      <div v-if="searchedOptions.length">
        <div v-for="(item, index) in searchedOptions" :key="index" class="item">
          <a class="flex items-center tl fs-14 lh-17 pl-16 pr-16 pb-8 pt-8 gray-dark hand" @click="handlSelect(item)">
            <span v-html="highlightText(item.name)"></span>
          </a>
        </div>
      </div>
      <div v-else class="fs-12 lh-16 pt-8 pb-8 pl-16 pr-16 fw-600-arial">
        No results
      </div>
    </div>
    <div v-else>
      <template v-if='!popularDestinations.length'>
        <div v-for="(item, index) in options" :key="index" class="item">
          <a class="flex items-center tl fs-14 lh-17 pl-16 pr-16 pb-8 pt-8 gray-dark hand" @click="handlSelect(item)">
            <span v-html="highlightText(item.name)"></span>
          </a>
        </div>
      </template>
      <template v-else>
        <div v-for="(item, index) in popularDestinations" :key='index'>
          <div v-if='item.title' class="fs-14 lh-16 pt-8 pb-8 pl-16 pr-16 fw-600-arial">{{item.title}}</div>
          <div
            v-for="(subItem, idx) in item.items"
            :key="idx"
            class="custom-option-item hand"
            @click="handlSelect(subItem)"
          >
            <span>{{ subItem.name }}</span>
          </div>
        </div>
      </template>
    </div>

  </div>
</template>

<script>
import {ref, computed, watchEffect, watch, nextTick, onMounted} from 'vue'
import ClickOutside from "~/directives/ClickOutside"

export default {
  directives:{
    ClickOutside
  },
  props:{
    options:{
      type: Array,
      default: null
    },
    modelValue: {
      type: Array,
      default: null
    },
    popularDestinations: {
      type: Array,
      default: () => []
    },
    placeHolderText: {
      type: String,
      default: 'Where would your client like to go?'
    }
  },
  emits:["update:modelValue"],
  setup(props, { emit }) {
    const searchRef = ref(null)
    const selectedArray = ref([])
    const showDropdown = ref(false)
    const searchQuery = ref('')

    const dataOptions = computed(() => {
      return props.popularDestinations.length ? props.popularDestinations : props.options
    })

    const toggleDropdown = () =>{
      showDropdown.value = !showDropdown.value
      nextTick(() => {
        if(showDropdown.value){
          searchRef.value.focus()
        }
      })
    }

    const closeDropdown = () => {
      showDropdown.value = false
    }

    const handlSelect = (data, disabled = false) => {
      if (disabled) return;
      // return when item was selected
      let exist = selectedArray.value.filter(item => parseInt(item.id) === parseInt(data.id) )
      if (exist.length) return;

      selectedArray.value.push(data)
      searchQuery.value = ''
      showDropdown.value = false;
      emit("update:modelValue", selectedArray.value)
    }

    const handleEnterKey = () => {
      if(searchedOptions.value.length && searchQuery.value) {
        handlSelect(searchedOptions.value[0])
      } else return;
    }

    const handleRemove = (index) =>{
      selectedArray.value.splice(index, 1)
      emit("update:modelValue", selectedArray.value)
    }

    watchEffect(()=>{
      if(!showDropdown.value){
        searchQuery.value = ''
      }
    })

    watch(
      () => props.modelValue,
      (value) => {
        selectedArray.value = value
      },
    )

    const searchedOptions = computed(() => {
      return props.options.filter((option) => {
        return (option.name.toLowerCase().indexOf(searchQuery.value.toLowerCase()) != -1)
      })
    })

    const highlightText = (text) => {
      let query = searchQuery.value.endsWith(`\\`) ? searchQuery.value.slice(0, -1) : searchQuery.value
      return text.replace(new RegExp(query, 'gi'), (match) => {
        return '<span class="highlighted">' + match + '</span>'
      })
    }

    onMounted(() => {
      selectedArray.value = props.modelValue
    })

    return {
      toggleDropdown,
      showDropdown,
      closeDropdown,
      selectedArray,
      handlSelect,
      handleRemove,
      searchQuery,
      searchedOptions,
      highlightText,
      searchRef,
      dataOptions,
      handleEnterKey
    }
  },
}
</script>

<style lang="scss">
.select-container{
  position: relative;
  display: flex;
  align-items: center;
  border: 1px solid $border; // Wave 7 → seam (#2E2E2E dark; was $gray-medium)
  min-height: 44px; // v2 §Text Input L167 — 44px min touch height (was 40px)
  height: 100%;
  cursor: pointer;
  color: $foreground; // Wave 7 → seam (near-white in dark)
  padding: 6px 0 6px 40px;
  border-radius: $radius-xl; // v2 §Text Input L167 — 12px (was $radius-lg/8px)
  text-align: left;
  &.has-value{
    background: rgba($brand-green, 0.08);
    border: 1px solid $brand-green;
  }
  .icon-search{
    position: absolute;
    left: 15px;
    top: 12px;
  }
  ul{
    height: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    li{
      font-size: 14px;
      line-height: 17px;
      &.select-item{
        position: relative;
        margin-right: 10px;
        &.styling{
          border: 1px solid $brand-green;
          padding: 6px 25px 6px 12px;
          border-radius: $radius-pill;
          margin-bottom: 5px;
        }
        .icon-delete{
          top: 10px;
          position: absolute;
          right: 8px;
          cursor: pointer;
          display: none;
          &.styling{
            display: block;
          }
        }
      }
    }
  }
  .input-search{
    width: 250px;
    padding: 0;
    height: auto;
    outline: none;
    border: 0;
    display: inline-block;
    font-size: 14px;
    color: $gray-dark;
    background: transparent;
    cursor: pointer;
    border-radius: 5px;
    text-align: left;
    // W7 dark: editable search input — $gray-dark (#5c5c5c raw, won't flip) on the dark container → foreground.
    [data-theme='dark'] & { color: $foreground; }
    &.input-full {
      width: 100%;
    }
    // input.input-search carries NO border/outline in any state (per request); border:0 + outline:none above.
    // Focus feedback lives on the wrapper (.select-container:focus-within) so keyboard focus stays visible.
  }

  &:hover {
    border: 1px solid $brand-green;
  }
  &:focus-within {
    border-color: $brand-green;
  }
}
.options{
  .item{
    a{
      &:hover,
      &:focus,
      &:active{
        background: rgba($brand-green, 0.08);
        color: $link-strong;
      }
    }
  }
}
.highlighted {
  font-weight: 700;
}
.traveller .select-container .input-search {width: 180px}
</style>
